export default __webpack_public_path__ + "static/media/dark-theme.6a68a5b4.png";